export default __webpack_public_path__ + "static/invisi-s-995397df7cdc752bf6aef33463c2a3e3.mp4";